export default "__VITE_ASSET__Bu6jShnx__"